import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CourseProvider } from "./context/CourseContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { HomePage } from "./pages/HomePage";
import WelcomeHomePage from "./pages/WelcomeHomePage";
import { ChaptersPage } from "./pages/ChaptersPage";
import { ChapterDetailPage } from "./pages/ChapterDetailPage";
import { BookmarksPage } from "./pages/BookmarksPage";
import { ProgressPage } from "./pages/ProgressPage";
import { EbookLandingPage } from "./pages/EbookLandingPage";
import { PurchaseSuccessPage } from "./pages/PurchaseSuccessPage";
import AdminAssistantPage from "./pages/AdminAssistantPage";
import LaunchDashboardPage from "./pages/LaunchDashboardPage";
import CollectiveLandingPage from "./pages/CollectiveLandingPage";
import CollectiveWelcomePage from "./pages/CollectiveWelcomePage";
import CirclePortalPage from "./pages/CirclePortalPage";
import PracticeLandingPage from "./pages/PracticeLandingPage";
import PracticePortalPage from "./pages/PracticePortalPage";
import PracticeWelcomePage from "./pages/PracticeWelcomePage";
import BundleLandingPage from "./pages/BundleLandingPage";
import BundleWelcomePage from "./pages/BundleWelcomePage";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ThemeProvider>
        <CourseProvider>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<WelcomeHomePage />} />
              <Route path="/course" element={<HomePage />} />
              <Route path="/chapters" element={<ChaptersPage />} />
              <Route path="/chapter/:id" element={<ChapterDetailPage />} />
              <Route path="/bookmarks" element={<BookmarksPage />} />
              <Route path="/progress" element={<ProgressPage />} />
              <Route path="/ebook" element={<EbookLandingPage />} />
              <Route path="/purchase-success" element={<PurchaseSuccessPage />} />
              <Route path="/webinar" element={<Navigate to="/" replace />} />
              <Route path="/admin/assistant" element={<AdminAssistantPage />} />
              <Route path="/admin/launch" element={<LaunchDashboardPage />} />
              <Route path="/collective" element={<CollectiveLandingPage />} />
              <Route path="/collective/welcome" element={<CollectiveWelcomePage />} />
              <Route path="/circle" element={<CirclePortalPage />} />
              <Route path="/practice" element={<PracticeLandingPage />} />
              <Route path="/practice/welcome" element={<PracticeWelcomePage />} />
              <Route path="/practice/library" element={<PracticePortalPage />} />
              <Route path="/bundle" element={<BundleLandingPage />} />
              <Route path="/bundle/welcome" element={<BundleWelcomePage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster 
            position="bottom-right" 
            richColors 
            toastOptions={{
              className: 'font-body',
            }}
          />
        </CourseProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
